import { formatWineType as formatWineTypeBase } from '@wineryxplorer/shared';
import type { WineType, PopulatedWine } from '@wineryxplorer/shared';
import type { BackNavigation } from './types';

export const formatWineType = (wineType: WineType): string => {
  return `${formatWineTypeBase(wineType)} Wine`;
};

// Check if error is likely a network error
export const isNetworkError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false;
  
  const errorObj = error as { message?: string; data?: { code?: string }; code?: string };
  const message = errorObj.message?.toLowerCase() || '';
  const code = errorObj.data?.code || errorObj.code || '';
  
  return (
    message.includes('network') ||
    message.includes('fetch') ||
    message.includes('connection') ||
    message.includes('timeout') ||
    code === 'NETWORK_ERROR' ||
    code === 'FETCH_ERROR' ||
    code === 'TIMEOUT'
  );
};

// Determine appropriate back navigation destination
export const getBackNavigation = (
  _location: { state?: { from?: string } },
  _wine?: PopulatedWine
): BackNavigation => {
  // Always return a simple "Back" navigation
  return { to: 'back', label: 'Back' };
};